import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgQd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.572 66.143L32.286 80c-1.714.286-3.429.572-5.143 1.143-5.286 1.571-9.857 4.714-13.286 9.143C-6 116 15.286 149.714 45.715 143l72.857-10.571c7.714-1.715 14.285-6.286 18.714-12.858 18.857-28.142-5.572-63.142-38.714-53.428z",
    fill: "url(#QD_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.143 14.857C54 7.43 42 3.857 28.429 7.714c-5.572 1.715-10.572 5.143-14.143 9.857-13.572 17.572-9 38.715 4.571 49.572l72.572 60.571c7.285 4.857 16.714 7 27.142 4.715 7.715-1.715 14.286-6.286 18.715-12.858 11.143-16.714 7.143-36-5-46.714l-70.143-58z",
    fill: "url(#QD_svg__paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.714 6.286C34.143 6.572 31 7 28.43 7.857c-5.572 1.572-10.572 5-14.143 9.715-21.143 27.428 1.571 63.142 33.857 56L135 40.857c2.571-.571 4.714-2 6.143-4.285 5.428-8.143-.143-18-9-18L41.286 6.143c-1.286 0-2.429 0-3.572.143z",
    fill: "url(#QD_svg__paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.857 32.143H32.143v85.714h85.714V32.143z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75 101.714H42.857v5.429H75v-5.429zM70.715 75.858l-3.572-3.143c-2.714 1.714-6 2.714-9.571 2.714-9.857 0-17-7.429-17-16.429v-.142c0-9.143 7.143-16.572 17.143-16.572s17 7.429 17 16.429v.143c0 3.428-1 6.571-2.858 9.142l3.286 2.858-4.428 5zM62 68.143l-5.285-4.428 4.428-5 5.286 4.714c.571-1.286.857-2.857.857-4.429v-.142c0-5.429-4-10.143-9.714-10.143-5.715 0-9.572 4.428-9.572 10v.143C48 64.286 52 69 57.715 69c1.571 0 3-.285 4.285-.857zM80.286 42.857H92.43c10.143 0 17 6.858 17 16V59c0 9-7 16-17 16H80.286V42.857zm7 6.286v19.429h5C98 68.572 102 64.715 102 59v-.143c0-5.714-3.857-9.714-9.714-9.714h-5z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "QD_svg__paint0_linear",
    x1: 3.347,
    y1: 114.288,
    x2: 115.717,
    y2: 98.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#FC7A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#FF318C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "QD_svg__paint1_linear",
    x1: -13.06,
    y1: 4.458,
    x2: 146.771,
    y2: 123.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#B544C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#FF318C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "QD_svg__paint2_linear",
    x1: -31.61,
    y1: 57.076,
    x2: 145.603,
    y2: 15.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D73BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#9D4AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#7953F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#6B57FF"
  })))));
}

export { SvgQd as ReactComponent };
